import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useAppKit, useAppKitAccount, useDisconnect } from "@reown/appkit/react";
import { trimAddress } from "../utils/helper";
import { toast } from "react-toastify";

const MasterLayout = ({ children }) => {
  const { profile, logout } = useAuth(); // get login method from context
  const { open } = useAppKit();
  const { isConnected, address } = useAppKitAccount();
  const { disconnect } = useDisconnect();

  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation(); // Hook to get the current route

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
              ? "sidebar sidebar-open"
              : "sidebar"
        }>
        <button
          onClick={mobileMenuControl}
          type="button"
          className="sidebar-close-btn">
          <Icon icon="radix-icons:cross-2" />
        </button>
        <div>
          <Link to="/dashboard" className="sidebar-logo">
            <img
              style={{
                width: "250px",
                height: "80px",
              }}
              src="/assets/images/logo.svg"
              alt="site logo"
              className="light-logo"
            />

            <img
              src="/assets/images/favicon.svg"
              alt="site logo"
              className="logo-icon"
            />
          </Link>
        </div>
        <div className="sidebar-menu-area">
          <ul className="sidebar-menu " id="sidebar-menu">
            <li>
              <NavLink
                to="/dashboard"
                className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }>
                <Icon
                  icon="solar:home-smile-angle-outline"
                  className="menu-icon"
                />
                <span>Dashboard</span>
              </NavLink>
            </li>

            {/* Users Dropdown */}

            <li>
              <NavLink
                to="/users-list"
                className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }>
                <Icon
                  icon="flowbite:users-group-outline"
                  className="menu-icon"
                />
                <span>User Management</span>
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/campaign-manage"
                className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }>
                <Icon icon="mdi:parachute" className="menu-icon" />
                <span>Airdrop Campaign</span>
              </NavLink>
            </li>

            <li className="dropdown">
              <Link to="#">
                <Icon icon="ri:nft-line" className="menu-icon" />
                <span>NFT Management</span>
              </Link>
              <ul className="sidebar-submenu">
                <li>
                  <NavLink
                    to="/nft-list"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }>
                    <Icon icon="ic:outline-image" className="menu-icon" width="24" height="24" />
                    <span>NFT List</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/nft-collections"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }>
                    <Icon icon="ic:outline-collections" className="menu-icon" width="24" height="24" />
                    <span>NFT Collections</span>
                  </NavLink>
                </li>


                <li>
                  <NavLink
                    to="/nft-marketplace"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }>
                    <Icon icon="mdi:cart-outline" className="menu-icon" width="24" height="24" />
                    <span>NFT Marketplace</span>
                  </NavLink>
                </li>

              </ul>
            </li>

            <li className="sidebar-menu-group-title">Application</li>

            <li className="dropdown">
              <Link to="#">
                <Icon
                  icon="material-symbols:description-outline"
                  className="menu-icon"
                />
                <span>Content</span>
              </Link>
              <ul className="sidebar-submenu">
                <li>
                  <NavLink
                    to="/terms-condition"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }>
                    <Icon icon="octicon:info-24" className="menu-icon" />
                    <span>Terms & Conditions</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/privacy-policy"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }>
                    <i className="ri-rocket-line menu-icon"></i>
                    <span>Privacy Policy</span>
                  </NavLink>
                </li>

                {/* <li>
                  <NavLink
                    to="/about-us"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }>
                    <i className="ri-hammer-line menu-icon"></i>
                    <span>About Us</span>
                  </NavLink>
                </li> */}
                <li>
                  <NavLink
                    to="/faq"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }>
                    <Icon
                      icon="mage:message-question-mark-round"
                      className="menu-icon"
                    />
                    <span>FAQs</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/newsletter"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }>
                    <Icon
                      icon="mdi:newspaper-variant-outline"
                      className="menu-icon"
                    />
                    <span>Newsletter</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/help-center"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }>
                    <Icon
                      icon="mdi:headset"
                      className="menu-icon"
                    />
                    <span>Help Center</span>
                  </NavLink>
                </li>
              </ul>
            </li>

            <li>
              <NavLink
                to="/notifications"
                className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }>
                <Icon icon="mdi:bell-outline" className="menu-icon" />
                <span>Notifications</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}>
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <button
                  type="button"
                  className="sidebar-toggle"
                  onClick={sidebarControl}>
                  {sidebarActive ? (
                    <Icon
                      icon="iconoir:arrow-right"
                      className="icon text-2xl non-active"
                    />
                  ) : (
                    <Icon
                      icon="heroicons:bars-3-solid"
                      className="icon text-2xl non-active "
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type="button"
                  className="sidebar-mobile-toggle">
                  <Icon icon="heroicons:bars-3-solid" className="icon" />
                </button>
              </div>
            </div>
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <button className="btn btn-primary" onClick={() => {
                  open()
                }}>
                  {!isConnected ? "Connect Wallet" :
                    <span className="d-flex align-items-center gap-2" onClick={() => disconnect()}>
                      {trimAddress(address, 5, 3)}
                      <Icon icon="lucide:log-out" className="icon text-xl" />
                    </span>
                  }
                </button>
                <div className="dropdown">
                  <button
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    type="button"
                    data-bs-toggle="dropdown">
                    <img
                      src="https://wow-dash.com/demo/assets/images/user.png"
                      alt="image_user"
                      className="w-40-px h-40-px object-fit-cover rounded-circle"
                    />
                  </button>
                  <div className="dropdown-menu to-top dropdown-menu-sm">
                    <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-primary-light fw-semibold mb-2">
                          {profile.name}
                        </h6>
                      </div>
                      <button type="button" className="hover-text-danger">
                        <Icon
                          icon="radix-icons:cross-1"
                          className="icon text-xl"
                        />
                      </button>
                    </div>
                    <ul className="to-top-list">
                      <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                          to="/view-admin-profile">
                          <Icon
                            icon="solar:user-linear"
                            className="icon text-xl"
                          />{" "}
                          My Profile
                        </Link>
                      </li>
                      <li>
                        <button
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                          onClick={async () => {
                            await logout();
                            toast.success("Admin logged out successfully.");
                          }}>
                          <Icon icon="lucide:power" className="icon text-xl" />{" "}
                          Log Out
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className="dashboard-main-body">{children}</div>

        {/* Footer section */}
        <footer className="d-footer">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <p className="mb-0">
                © {new Date().getFullYear()} Soli Coin. All Rights Reserved.
              </p>
            </div>
            <div className="col-auto">
              <p className="mb-0">
                Made by <span className="text-primary-600">dev-technosys</span>
              </p>
            </div>
          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;
